import dayjs from "dayjs";

// 预约时间统一按 Europe/London 的"墙上时间"存储为 `YYYY-MM-DDTHH:mm`（不含时区），
// 展示时原样格式化，避免任何时区换算造成的偏差。
export const SHOOT_AT_STORE_FORMAT = "YYYY-MM-DDTHH:mm";

export function serializeShootAt(value) {
    if (!value) {
        return "";
    }
    const d = dayjs(value);
    return d.isValid() ? d.format(SHOOT_AT_STORE_FORMAT) : "";
}

export function formatShootAtDisplay(shootAt) {
    if (!shootAt) {
        return "";
    }
    const d = dayjs(shootAt);
    return d.isValid() ? d.format("YYYY.MM.DD HH:mm") : shootAt;
}

export function formatShootAtDate(shootAt) {
    if (!shootAt) {
        return "";
    }
    const d = dayjs(shootAt);
    return d.isValid() ? d.format("YYYY.MM.DD") : shootAt;
}

export function formatShootAtTime(shootAt) {
    if (!shootAt) {
        return "";
    }
    const d = dayjs(shootAt);
    return d.isValid() ? d.format("HH:mm") : "";
}

export function formatCreatedAt(createdAtSeconds) {
    if (!createdAtSeconds) {
        return "";
    }
    return dayjs.unix(createdAtSeconds).format("YYYY.MM.DD HH:mm");
}
